module.exports = __webpack_public_path__ + "07_bob_beige.2db7664e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_bob_beige.png
// module id = qIvn
// module chunks = 0